import { useLocalSearchParams } from 'expo-router';

import { PeopleScreen } from '@/components/domain/members/PeopleScreen';
import { peopleListTypes, type PeopleListType } from '~/constants/lists';

function parseFromParam(from: unknown): PeopleListType {
  if (typeof from !== 'string' || from === 'search') return 'online';
  return (peopleListTypes as readonly string[]).includes(from)
    ? (from as PeopleListType)
    : 'online';
}

export default function PeopleSearchScreen() {
  const { from } = useLocalSearchParams<{ from?: string }>();
  const lastUsedListType = parseFromParam(from);
  return <PeopleScreen listType="search" lastUsedListType={lastUsedListType} />;
}
